export default __webpack_public_path__ + "4dde71035c4b41e6d0d19d3c8b877105.png";